import {
  OTHERGOODS_HISTORY_FAILED,
  OTHERGOODS_HISTORY_REQUEST,
  OTHERGOODS_HISTORY_SUCCESS,
} from "app/redux/actions/Inventory/otherGoods/constants.js";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const otherGoodsHistoryReducer = function (
  state = INIT_STATE,
  action
) {

  switch (action?.type) {
    case OTHERGOODS_HISTORY_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case OTHERGOODS_HISTORY_SUCCESS:
      console.log("payload => ", action?.payload?.data);
      return {
        loading: false,
        data: action?.payload?.data,

        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case OTHERGOODS_HISTORY_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
